import React from 'react';
import { Image } from '@tangibleplay/core-ui';

import { StyledProductMiniature } from './ProductMiniature.styles';

import { ProductMiniatureProps } from './ProductMiniature.types';

const ProductMiniature = ({
  product,
  productImageSlot,
  productNameSlot,
  productPrice,
  children,
  linkToProductPage,
  renderLink,
  imageHeight,
  imageWidth,
  componentClassname = 'product-miniature',
  customClassnames = '',
  customStyle = '',
  ...props
}: ProductMiniatureProps) => {
  const getProductImage = () => {
    if (productImageSlot) {
      return productImageSlot;
    }
    if (!product.image_link) {
      return null;
    }
    if (linkToProductPage) {
      if (renderLink) {
        return renderLink({
          href: linkToProductPage,
          children: (
            <Image
              src={product.image_link}
              alt={product.title}
              imageHeight={imageHeight}
              imageWidth={imageWidth}
            />
          ),
          additionalParams: {
            className: `${componentClassname}__image`,
          },
        });
      }
      return (
        <a href={linkToProductPage} className={`${componentClassname}__image`}>
          <Image
            src={product.image_link}
            alt={product.title}
            imageHeight={imageHeight}
            imageWidth={imageWidth}
            style={{}}
          />
        </a>
      );
    }
    return (
      <div className={`${componentClassname}__image`}>
        <Image
          src={product.image_link}
          alt={product.title}
          imageHeight={imageHeight}
          imageWidth={imageWidth}
        />
      </div>
    );
  };

  const getProductName = () => {
    if (productNameSlot) {
      return productNameSlot;
    }
    if (linkToProductPage) {
      if (renderLink) {
        return renderLink({
          href: linkToProductPage,
          children: product.title,
          additionalParams: {
            className: `${componentClassname}__name`,
          },
        });
      }
      return (
        <a href={linkToProductPage} className={`${componentClassname}__name`}>
          {product.title}
        </a>
      );
    }
    return <div className={`${componentClassname}__name`}>{product.title}</div>;
  };

  return (
    <StyledProductMiniature
      className={`${componentClassname} ${customClassnames}`}
      customStyle={customStyle}
      {...props}
    >
      {getProductImage()}
      {getProductName()}
      {productPrice && (
        <div className={`${componentClassname}__price`}>{productPrice}</div>
      )}
      {children}
    </StyledProductMiniature>
  );
};
ProductMiniature.displayName = 'ProductMiniature';

export default ProductMiniature;
